<script setup lang="ts">
import Slider from '@vueform/slider'
import '~/assets/css/slider.css'

// fix Error: noUiSlider: Slider was already initialized.
const mountedForSlider = ref(false)

onMounted(() => {
  // timeout
  setTimeout(() => {
    mountedForSlider.value = true
  }, 100)
})
</script>

<template>
  <Slider
    v-if="mountedForSlider"
    v-bind="$attrs"
    class="slider-primary straight-tooltip mb-2 mt-10"
  />
</template>

<i18n lang="json">
{
  "en": {
    "": ""
  },
  "nl": {
    "": ""
  }
}
</i18n>
